import axios from './BaseService';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/$/, '');
const SETTINGS_URL = `${API_BASE}/settings`;

export function getProfilePhotoUrl(profilePhoto) {
    if (!profilePhoto) return null;
    if (profilePhoto.startsWith('http') || profilePhoto.startsWith('data:')) {
        return profilePhoto;
    }
    return `${API_BASE}${profilePhoto.startsWith('/') ? profilePhoto : `/${profilePhoto}`}`;
}

export async function getSettings() {
    const response = await axios.get(SETTINGS_URL);
    return response.data;
}

export async function updateSettings(settings) {
    const response = await axios.patch(SETTINGS_URL, settings);
    return response.data;
}